import "./shims/fetch-proxy";
import { seedDemoData } from "./demo/seed";

// The stores read the local databases as soon as the app is loaded, so the
// demo data has to be in place before the app module is required.
function start() {
  const { AppRegistry } = require("react-native");
  const App = require("../App").default;

  AppRegistry.registerComponent("TailPOS", () => App);
  AppRegistry.runApplication("TailPOS", {
    rootTag: document.getElementById("root"),
  });
}

seedDemoData()
  .catch(error => console.warn("Demo data was not loaded", error))
  .then(start);
